<div fxLayout="column" fxLayoutGap="8" style="margin-top: .5rem">
  <div fxFlex>
    <h1 mat-dialog-title align="center">Cadastro de usuários</h1>
  </div>

  <!-- Aviso de protecao para administradores que editam o proprio perfil -->
  <div *ngIf="isSelfAdminEdit" style="background:#fff3e0;border-left:4px solid #ff9800;padding:8px 12px;margin-bottom:4px;border-radius:4px;font-size:13px;color:#e65100;">
    <mat-icon style="vertical-align:middle;font-size:16px;margin-right:4px">lock</mat-icon>
    Como administrador, voce nao pode alterar seu proprio e-mail, usuario (login) ou grupo de acesso.
  </div>
  <form (submit)="onSubmit()" autocomplete="off" fxFlex>
    <div fxLayout.gt-md="row" fxLayout.gt-sm="column">

      <!-- DADOS PRINCIPAIS -->
      <div fxFlex fxFlex.gt-md="100" fxFlex.gt-sm="100" fxLayout="column" class="card mat-elevation-z4" fxLayoutGap="5">

        <!-- ROW -->
        <div id="user-data" fxLayout.gt-md="row" fxLayout.gt-sm="column" fxLayoutGap="20">
          <div fxFlex fxLayout="column" fxFill>
            <div id="info-first-row" fxLayout.gt-md="row" fxLayout.gt-sm="column" fxLayout.gt-xs="column"
              fxLayoutGap="10">
              <div fxFlex.gt-sm="100" fxFlex.gt-md="25"
                [matTooltip]="isSelfAdminEdit ? 'Voce nao pode alterar o proprio grupo de acesso' : ''"
                matTooltipPosition="above">
                <app-select-advanced-search [isMultipleSelect]="true" [config]="getFieldConfig('userGroups')"
                  [group]="form"></app-select-advanced-search>
              </div>
              <div fxFlex.gt-sm="100" fxFlex.gt-md="30">
                <app-select [isMultipleSelect]="true" [config]="getFieldConfig('branches')"
                  [group]="form"></app-select>
              </div>
              <div fxFlex.gt-sm="100" fxFlex.gt-md="20">
                <app-input-text [config]="getFieldConfig('firstName')" [group]="form"></app-input-text>
              </div>
              <div fxFlex.gt-sm="100" fxFlex.gt-md="25">
                <app-input-text [config]="getFieldConfig('lastName')" [group]="form"></app-input-text>
              </div>
            </div>

            <div id="info-second-row" fxLayout.gt-md="row" fxLayout.gt-sm="column" fxLayout.gt-xs="column"
              fxLayoutGap="10">
              <div fxFlex="100">
                <app-input-text mask="000.000.000-99" [config]="getFieldConfig('document')"
                  [group]="form"></app-input-text>
              </div>
              <div fxFlex="100"
                [matTooltip]="isSelfAdminEdit ? 'Voce nao pode alterar o proprio login' : ''"
                matTooltipPosition="above">
                <app-input-text [config]="getFieldConfig('username')" [group]="form"></app-input-text>
              </div>
              <div fxFlex="100">
                <app-input-text mask="(00)00000-0009" [config]="getFieldConfig('phone')"
                  [group]="form"></app-input-text>
              </div>
              <div fxFlex="100"
                [matTooltip]="isSelfAdminEdit ? 'Voce nao pode alterar o proprio e-mail' : ''"
                matTooltipPosition="above">
                <app-input-text [config]="getFieldConfig('email')" [group]="form"></app-input-text>
              </div>
            </div>
          </div>
        </div>

        <mat-divider></mat-divider>
        <!-- MARCADORES -->
        <h2>Definições</h2>
        <div id="options" fxFlex fxFill fxLayout="row" fxLayoutAlign="space-evenly center" fxFlexAlign="stretch"
          class="controls" fxLayoutGap="10">
          <div id="customer-image" fxFlex="12%" fxFill>
            <app-image [config]="getFieldConfig('image')" [group]="form"></app-image>
          </div>
          <mat-divider [vertical]="true" style="height: 100%;"></mat-divider>
          <div *ngIf="action.isCreateAction()">
            <h3>Configuração de primeiro acesso</h3>
            <app-input-text [config]="getFieldConfig('password')" [group]="form"></app-input-text>
            <app-input-text [config]="getFieldConfig('confirmPassword')" [group]="form">
            </app-input-text>
            <mat-error *ngIf="form?.hasError('passwordsMismatch')">* As senhas não
              coincidem</mat-error>
          </div>
          <div fxLayoutGap="40">
            <app-slide-toggle [group]="form" [config]="getFieldConfig('requireChangePassword')"></app-slide-toggle>
          </div>
        </div>
      </div>
    </div>

    <!-- AÇÕES -->
    <div fxLayout="row" fxLayoutGap="20" fxLayoutAlign="flex-end" style="padding-right: 4rem; padding-left: 1.5rem;">
      <button class="custom-button" type="button" routerLink="/users" mat-raised-button>Fechar <i
          class="material-icons">close</i></button>
      <button class="custom-button" type="button" mat-raised-button (click)="openPermissionsDialog()"
        [disabled]="isSelfAdminEdit"
        [matTooltip]="isSelfAdminEdit ? 'Voce nao pode alterar as proprias permissoes' : ''">
        PERMISSÕES<i class="material-icons" style="margin-left:4px">security</i>
        <span *ngIf="permissionCount > 0" style="margin-left:4px;font-weight:bold">({{ permissionCount }})</span>
      </button>
      <button [disabled]="form.invalid" class="custom-button btn-save" type="submit" variant="contained"
        mat-raised-button>
        Salvar Cadastro <i class="material-icons">save</i></button>
    </div>
  </form>
</div>
